import React from 'react'
import styles from './styles'
const Loader = () => {
  return (
    <div className={`loader-container ${styles.loaderContainer}`}>
      <div className={`loader ${styles.loader}`}></div>
      <p className={styles.accessiblyHidden}>Loading...</p>
    </div>
  )
}

export default Loader
